export default "__VITE_ASSET__DDzajMRB__"